<script>
export default {
  emits: ["drop-item"],
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    keyValue: {
      type: String,
      default: "id",
    },
    labelValue: {
      type: String,
      default: "name",
    },
  },
  methods: {
    dropItem(item) {
      this.$emit("drop-item", item[this.keyValue]);
    },
  },
};
</script>

<template>
  <div class="flex flex-row text-left flex-wrap gap-4">
    <div
      v-for="item in items"
      :key="item"
      class="flex flex-row items-center px-4 py-1 gap-4 rounded-full bg-primary/30 antialiased cursor-default"
    >
      {{ item[labelValue] }}
      <fas
        :icon="['fas', 'trash']"
        @click="dropItem(item)"
        class="cursor-pointer"
      />
    </div>
  </div>
</template>
